import { init as initApm } from '@elastic/apm-rum';
import config from './config';

// Elastic RUM, same server and shape as the other kompare funnels (dzo-webshop,
// ao-checkout). Captures page loads, route changes (ApmRoutes in main.router.tsx), every
// XHR/fetch with its status code, unhandled errors, and whatever we captureError()
// ourselves (captcha events in common/utils/captchaTelemetry.util.ts). Off in local
// development; `environment` is the deploy target derived from the hostname (production
// | work | top | …) and `serverUrl` follows it, so dev traffic lands in the dev APM stack.
//
// Deliberately NO distributedTracingOrigins: a `traceparent` header turns the createSo
// POST into a CORS-preflighted request, and no kompare backend runs an APM agent that
// could receive it (funnel-hardening playbook §1/§6; dzo-webshop removed its 2026-09-22).
const apm =
  config.REACT_APP_ENVIRONMENT !== 'development'
    ? initApm({
        serviceName: 'putno-osiguranje-webshop',
        serverUrl: config.REACT_APP_APM_SERVER_URL,
        environment: config.REACT_APP_ENVIRONMENT,
        serviceVersion: __APP_VERSION__,
        breakdownMetrics: true,
      })
    : undefined;

// Third-party scripts on the page (GTM, Tawk, Chatwoot) throw opaque cross-origin
// "Script error." — the bulk of RUM error volume on the CRM frontends is that one line.
// The agent has no ignoreErrors option, so drop them in the outgoing payload filter.
const IGNORED_ERROR_MESSAGES = [/^Script error\.?$/, /ResizeObserver loop/];

apm?.addFilter((payload) => {
  if (Array.isArray(payload?.errors)) {
    payload.errors = payload.errors.filter(
      (error: { exception?: { message?: string } }) =>
        !IGNORED_ERROR_MESSAGES.some((pattern) => pattern.test(error?.exception?.message ?? ''))
    );
  }
  return payload;
});

export default apm;
